export default {"src":"__ASTRO_ASSET_IMAGE__BjizViaA__","width":264,"height":192,"format":"svg"}